// extracted by mini-css-extract-plugin
export default {"gridForm":"SamlSSOProviderForm_gridForm__0qvIX","singleSignOnServiceUrl":"SamlSSOProviderForm_singleSignOnServiceUrl__rwx2s","idpEntityId":"SamlSSOProviderForm_idpEntityId__X7VRt"};